// Runtime environment helpers.
//
// Vite bakes `import.meta.env.*` values into the bundle as compile-time
// constants. Reading from `window.__env__` first allows the CI/CD pipeline to
// override values post-build via the public/env-config.js file without
// requiring a full rebuild.

type AppEnv = { __env__?: Record<string, string> };

function getRuntimeEnv(key: string): string | undefined {
  return (globalThis as AppEnv).__env__?.[key];
}

/**
 * Gets a config value, preferring runtime env (post-build injection via
 * env-config.js) over compile-time env (Vite .env files).
 *
 * Ignores unreplaced CI placeholder values of the form "{KEY_NAME}".
 */
export function getEnv(key: string): string {
  const runtimeValue = getRuntimeEnv(key);
  if (runtimeValue && !runtimeValue.startsWith("{")) return runtimeValue;
  return (import.meta.env[key] as string) ?? "";
}

export const IS_DEMO =
  getRuntimeEnv("VITE_APP_MODE") === "demo" ||
  import.meta.env.VITE_APP_MODE === "demo";

// Okta OIDC configuration (production mode only).
export const OKTA_ISSUER = getEnv("VITE_OKTA_ISSUER");
export const OKTA_CLIENT_ID = getEnv("VITE_OKTA_CLIENT_ID");
export const OKTA_REDIRECT_URI = getEnv("VITE_OKTA_REDIRECT_URI");
export const OKTA_POST_LOGOUT_REDIRECT_URI = getEnv(
  "VITE_OKTA_POST_LOGOUT_REDIRECT_URI",
);
